module.exports = __webpack_public_path__ + "img/86.b39aba2f.jpg";